import { AktionBeendet } from "@/components/AktionBeendet";

// Gewinnspiel für neue Konten: beendet (Frage 292, Sitzung „Aufräumen“, 14.10.2026). Die Einladungs-Automatik
// `raffle_invitation` ist seit 23.09.2026 aus, die letzte Teilnahme war am 23.09.2026, offene Gewinne gibt es
// keine mehr. Die Seite mit Losziehung steht in der Git-Historie; die Teilnahmebedingungen bleiben erreichbar.
const Gewinnspiel = () => (
  <AktionBeendet
    titel="Gewinnspiel"
    text="Das Gewinnspiel ist beendet. Mit deinem Konto kannst du MusiKonzept weiter nutzen."
    ziel={{ text: "Zu meinem Bereich", pfad: "/mein-bereich" }}
  />
);

export default Gewinnspiel;
